import { OrganizationMember } from "./organization_member";

export class OrganizationMembers extends Array<OrganizationMember> {
  constructor(organizationMembers?: OrganizationMember[]) {
    super();
    if (organizationMembers instanceof Array) {
      organizationMembers.forEach((organizationMember) =>
        this.push(organizationMember),
      );
    }
  }

  public filterBy(roles: string[]): OrganizationMembers {
    return new OrganizationMembers(
      this.filter((member) => roles.includes(member.roleLabel)),
    );
  }

  public queryBy(query: string): OrganizationMembers {
    return new OrganizationMembers(
      this.filter((position) => {
        return position.query(query);
      }),
    );
  }
}
